import { HELP_CENTER_URL } from '@utils/urls'
import { Layout, Space, theme, Typography } from 'antd'
import Gleap from 'gleap'
import React from 'react'
import { Link } from 'react-router-dom'

const { Footer } = Layout
const { Text } = Typography

export const LayoutFooter: React.FC = () => {
  const { token } = theme.useToken()
  const year = new Date().getFullYear()

  return (
    <Footer
      style={{ background: token.colorBgContainer, padding: '15px 25px' }}
    >
      <Space style={{ justifyContent: 'space-between' }} className="w-full">
        <Space size={30}>
          <Link
            to={'https://www.plethore.io?utm_source=dashboard'}
            target="_blank"
          >
            <Text style={{ fontWeight: 300 }}>Discover Pléthore</Text>
          </Link>
          <Link to={HELP_CENTER_URL} target="_blank">
            <Text style={{ fontWeight: 300 }}>Help</Text>
          </Link>

          <Link
            to={'#'}
            style={{ fontWeight: 300 }}
            onClick={() => Gleap.openNews(true)}
          >
            <Text style={{ fontWeight: 300 }}>Changelog</Text>
          </Link>

          <Link to={'https://www.plethore.io/legals'} target="_blank">
            <Text style={{ fontWeight: 300 }}>Legals</Text>
          </Link>
        </Space>
        <Text style={{ fontWeight: 300 }}>© {year} Supplément Bacon</Text>
      </Space>
    </Footer>
  )
}
